var _path;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], t.indexOf(o) >= 0 || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.indexOf(n) >= 0) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgArrow = function SvgArrow(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 8,
    viewBox: "0 0 39 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1 3.48038C0.713024 3.48038 0.480385 3.71302 0.480385 4C0.480385 4.28698 0.713024 4.51962 1 4.51962L1 3.48038ZM38.3674 4.36743C38.5703 4.1645 38.5703 3.8355 38.3674 3.63258L35.0606 0.325768C34.8577 0.122846 34.5287 0.122846 34.3258 0.325768C34.1228 0.528691 34.1228 0.857693 34.3258 1.06062L37.2652 4L34.3258 6.93939C34.1228 7.14231 34.1228 7.47132 34.3258 7.67424C34.5287 7.87716 34.8577 7.87716 35.0606 7.67424L38.3674 4.36743ZM1 4.51962L38 4.51962L38 3.48039L1 3.48038L1 4.51962Z",
    fill: "#646464"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgArrow);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "apps/static/media/arrow.ec1d14a2e70800f268c370f8d042f5b2.blank.svg";